import type { POI, POICategory } from "@/features/poi/types/poi.types";
import { createApi } from "@reduxjs/toolkit/query/react";
import { interactiveSurveyBaseQuery } from "./base";

export const poiApi = createApi({
  reducerPath: "poiApi",
  baseQuery: interactiveSurveyBaseQuery,
  tagTypes: ["POI", "POICategories"],
  endpoints: (build) => ({
    getPois: build.query<POI[], string>({
      query: (surveyId) => ({
        url: `poi/${surveyId}`,
      }),
      providesTags: [{ type: "POI", id: "LIST" }],
    }),
    getPoisCategories: build.query<POICategory[], string>({
      query: (surveyId) => ({
        url: `poi/${surveyId}/poiCategories`,
      }),
      providesTags: [{ type: "POICategories", id: "LIST" }],
    }),
  }),
});

export const { useGetPoisQuery, useGetPoisCategoriesQuery } = poiApi;
